import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useTheme } from "@mui/material/styles";
import React, { createContext } from "react";

const ToastContext = createContext<{
  showToast: (message: string, type: "success" | "error" | "warning" | "info") => void;
}>({
  showToast: () => null,
});

const ToastContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [type, setType] = React.useState<"success" | "error" | "warning" | "info">("info");

  const showToast = (newMessage: string, newType: "success" | "error" | "warning" | "info") => {
    setMessage(newMessage);
    setType(newType);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setMessage("");
    setType("info");
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={type}
          sx={{ width: "100%", bgcolor: isDarkMode ? "grey.200" : undefined }}
        >
          {message}
        </Alert>
      </Snackbar>
      {children}
    </ToastContext.Provider>
  );
};

export { ToastContext, ToastContextProvider };
